import NoData from "assets/svgs/no_data/NoData";
import moment from "moment";
import React from "react";
import { Placeholder } from "react-bootstrap";

function TransferTable({ transferFilterData, transferLoading }) {
  const header = ["From", "Total", "Status", "Remaining", "To", "Date"];
  return (
    <div>
      <div
        className="mt-1 shadow rounded  scrollable-container"
        style={{ maxHeight: "70vh", overflowY: "scroll" }}
      >
        <div
          className="d-flex table-head rounded-top"
          style={{ position: "sticky", top: "0" }}
        >
          {header?.map((transferData) => {
            return (
              <span className="p-3 py-4 fw-bold text-black flex-1 border-end">
                {transferData}
              </span>
            );
          })}
        </div>
        {transferLoading ? (
          <>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={12} />
            </Placeholder>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={12} />
            </Placeholder>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={12} />
            </Placeholder>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={12} />
            </Placeholder>
          </>
        ) : transferFilterData && transferFilterData?.length ? (
          transferFilterData?.map((transferData, index) => {
            return (
              <div
                className={`d-flex table-row border-1 border-top-0 ${
                  index === transferFilterData?.length - 1 && `rounded-bottom`
                }`}
              >
                <span className="p-3  flex-1 text-break text-black text-wrap border-end">
                  {transferData?.originalRepName}
                </span>
                <span className="p-3 flex-1 text-break  text-wrap border-end cursor-pointer fw-bold text-primary">
                  {transferData?.total}
                </span>
                <span className="p-3 flex-1 text-break text-wrap border-end fw-bold cursor-pointer text-primary">
                  {transferData?.status}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {transferData?.remaining}
                </span>
                <span className="p-3 d-flex gap-4 flex-1 text-break text-black text-wrap border-end">
                  <ul>
                    {transferData?.targetRepNames?.map((name) => (
                      <li>{name}</li>
                    ))}
                  </ul>
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {moment(transferData?.createdAt).format(
                    "DD MMM YYYY hh:mm:ss a"
                  )}
                </span>
              </div>
            );
          })
        ) : (
          <div className="p-3 bg-white rounded-bottom text-center">
            No Data Available <NoData />
          </div>
        )}
      </div>
    </div>
  );
}

export default TransferTable;
